// #/services/workflows/updateWorkflow.ts
import { IWorkflow } from '#/types/workspace';
import { stringifyJson } from '#/utils/json';

import getWorkflow from './getWorkflow';
import writeWorkflow from './writeWorkflow';

export default async function updateWorkflow(args: {
  ownerAddress: string;
  workflowUuid: string;
  updatedWorkflow: Partial<IWorkflow>;
}): Promise<IWorkflow> {
  try {
    const { ownerAddress, workflowUuid, updatedWorkflow } = args;

    console.info('updateWorkflow(', JSON.stringify(args), ')');

    const currentWorkflow =
      (await getWorkflow({
        ownerAddress,
        workflowUuid,
      })) ?? {};

    const mergedWorkflow = {
      uuid: workflowUuid,
      ...currentWorkflow,
      ...updatedWorkflow,
    };

    console.debug('stringifyJson(mergedWorkflow)');
    console.debug(stringifyJson(mergedWorkflow));

    await writeWorkflow({
      ownerAddress,
      workflowUuid,
      workflow: mergedWorkflow,
    });

    return mergedWorkflow;
  } catch (error: any) {
    console.error(error);
    throw new Error(`Error updating workflow: ${error.message}`);
  }
}
